<div class="container">
  <form [formGroup]="tilesetFormGroup">
    <div class="input-container">
      <span class="title">{{'distance_min_in_m' | transloco}}</span>
      <input type="number"
             formControlName="min"
             step="0.1"
             (keydown.enter)="updateTilsetStyleColorConditions()"
             (focusin)="onInputHandleFocus($event)"
             (focusout)="onInputLeaveFocus($event)">
    </div>

    <div class="input-container">
      <span class="title">{{'distance_max_in_m' | transloco}}</span>
      <input type="number"
             formControlName="max"
             step="0.1"
             (keydown.enter)="updateTilsetStyleColorConditions()"
             (focusin)="onInputHandleFocus($event)"
             (focusout)="onInputLeaveFocus($event)">
    </div>
  </form>
</div>

